exports.install = function (Vue, options) {
  //catch 跳转到登录页
  Vue.prototype.abnormalSituation = function (data){
    let locale = localStorage.getItem('locale')
    if(locale == 'zh'){
      this.$router.push({
        name: "login"
      })
    }else if(locale == 'en'){
      this.$router.push({
        name: "loginEn"
      })
    }
  }
}